import { Briefcase, CircleDot, MapPin } from 'lucide-react'

import type { FilterOption } from '@/components/filters/filter-menu'
import {
  EMPLOYMENT_TYPE_LABELS,
  PUBLICATION_STATUS_LABELS,
  WORK_MODE_LABELS,
} from '@/utils/job-meta-labels'

import type { EmployerJobListFilters, EmployerJobsSort, PublicationStatusFilter } from './employer-jobs-types'

export const EMPLOYER_JOBS_DEFAULT_OPERATORS = {
  q_operator: 'contains',
  publication_status_operator: 'is',
  employment_type_operator: 'is',
  work_mode_operator: 'is',
} as const satisfies Pick<
  EmployerJobListFilters,
  | 'q_operator'
  | 'publication_status_operator'
  | 'employment_type_operator'
  | 'work_mode_operator'
>

export const EMPLOYER_JOBS_SORT_LABELS: Record<EmployerJobsSort, string> = {
  updated_desc: 'Recently updated',
  updated_asc: 'Oldest updated',
  title_asc: 'Title A–Z',
  title_desc: 'Title Z–A',
}

export const STATUS_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'Any status' },
  ...(Object.keys(PUBLICATION_STATUS_LABELS) as PublicationStatusFilter[]).map((key) => ({
    value: key,
    label: PUBLICATION_STATUS_LABELS[key],
  })),
]

export const EMPLOYMENT_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'Any employment' },
  ...(Object.keys(EMPLOYMENT_TYPE_LABELS) as (keyof typeof EMPLOYMENT_TYPE_LABELS)[]).map(
    (key) => ({
      value: key,
      label: EMPLOYMENT_TYPE_LABELS[key],
    }),
  ),
]

export const WORK_MODE_FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'Any work mode' },
  ...(Object.keys(WORK_MODE_LABELS) as (keyof typeof WORK_MODE_LABELS)[]).map((key) => ({
    value: key,
    label: WORK_MODE_LABELS[key],
  })),
]

export const SORT_FILTER_OPTIONS: FilterOption[] = (
  Object.keys(EMPLOYER_JOBS_SORT_LABELS) as EmployerJobsSort[]
).map((key) => ({
  value: key,
  label: EMPLOYER_JOBS_SORT_LABELS[key],
}))

export const EMPLOYER_JOBS_FILTER_ICONS = {
  publication_status: CircleDot,
  employment_type: Briefcase,
  work_mode: MapPin,
} as const
